import type { NewProjectQuickFormValues } from "../../../../../libs/form-validations/new-project-quick";
import {
    formatPhoneNumber,
    getPhoneCountry,
    phoneDigitsOnly,
} from "../../../../../utils/phone";

/** Map Quick form values into the Normal create-project payload shape. */
export function mapQuickFormToCreatePayload(data: NewProjectQuickFormValues) {
    const country = getPhoneCountry(data.customerPhoneCountry);
    const national = formatPhoneNumber(
        data.customerPhoneNumber,
        data.customerPhoneCountry,
    );
    const digits = phoneDigitsOnly(data.customerPhoneNumber);
    const customerPhoneNumber =
        country.code === "US" || country.code === "CA"
            ? national
            : `${country.dialCode}${digits}`;

    return {
        name: data.name,
        description: "",
        type: data.type,
        leadSource: null,
        secondaryLead: "",
        salesmanName: data.salesmanName,
        customerName: data.customerName,
        customerPhoneNumber,
        customerEmail: data.customerEmail || "",
        customerStreetAddress: data.customerStreetAddress,
        customerCity: data.customerCity,
        customerState: data.customerState,
        customerZipCode: data.customerZipCode,
        customerCountry: data.customerCountry,
        // Property address mirrors customer (Quick has a single address).
        propertyStreetAddress: data.customerStreetAddress,
        propertyCity: data.customerCity,
        propertyState: data.customerState,
        propertyZipCode: data.customerZipCode,
        propertyCountry: data.customerCountry,
        // Quick defaults — fill in later on the project if needed.
        evorderid: "",
        noEagleViewId: true,
        skipMeasurements: true,
        noInsurance: true,
        insuranceProvider: "",
        claimNumber: "",
        policyNumber: "",
        adjusterContact: "",
        adjusterEmail: "",
        secondarySalesmanName: "",
        // StartDate required by DB; use now when Quick has no schedule step.
        jobStartDate: new Date().toISOString(),
    };
}
